export const getModifiedFilters = (val) => {
  switch (val) {
    case "checked in":
      return "checked-in";
    case "in progress":
      return "in-progress";
    case "no show":
      return "no-show";
    case "Tele-Consult Regular":
      return "tele-consult-regular";
    case "Tele-Consult Follow-Up":
      return "tele-consult-follow-up";
    case "In-Clinic Regular":
      return "in-clinic-regular";
    case "In-Clinic Follow-Up":
      return "in-clinic-follow-up";
    case "Instant":
      return "instant";
    default:
      return val;
  }
};

export const addQueryForMyPatient = (history, location, key, value) => {
  let pathname = location.pathname;
  let searchParams = new URLSearchParams(location.search);
  key.forEach((param, index) => {
    // <==
    searchParams.set(key[index], value[index]);
  });
  history.push({
    pathname: pathname,
    search: searchParams.toString(),
  });
};

function removeParamForMyPatient(key, params) {
  let param,
    params_arr = [],
    queryString = params.indexOf("?") !== -1 ? params.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    let arr = params_arr.filter((pa) => {
      param = pa.split("=")[0];
      return !key.includes(param);
    });
    params = arr ? arr.join("&") : "";
  }
  return params;
}

export const removeQueryForMyPatient = (history, location, key) => {
  let pathname = location.pathname;
  let params = removeParamForMyPatient(key, location.search);
  history.push({
    pathname: pathname,
    search: params.toString(),
  });
};
